/* eslint-disable react/jsx-key */
import { ContentContainer } from "@twinkltech/curriculum-architect-component-library";
import { useTwinklAnalytics } from "@twinkltech/web-analytics-ts";
import { Button, Text } from "@twinkltech/web-ui";

import BlogPostImg from "@/assets/images/blog-post.png";
import CurriculumGoalsImg from "@/assets/images/curriculum-goals.png";

import { CurriculumGoalsBlogPosts } from "@/utils/BlogPostHelper/BlogPostHelper";
import { SubjectHelper } from "@/utils/SubjectHelper/SubjectHelper";

import { paths } from "@/paths";

import { CurriculumGoalsTick } from "./sub-component/CurriculumGoalsTick/CurriculumGoalsTick";

export const CurriculumGoals = () => {
  const { click } = useTwinklAnalytics();
  const includedItems = [
    "Rely on high-quality content crafted by subject specialists.",
    "Adapt sequencing to meet the needs of your school's unique context.",
    "Support for inclusive and adaptive teaching woven into every lesson.",
    "We’ll keep resources updated with the Curriculum & Review outcomes.",
  ];

  return (
    <ContentContainer>
      <div className="flex flex-col max-w-[1200px]">
        <div className="flex gap-6 mb-10" role="region">
          <div className="max-w-[800px] flex flex-col gap-2">
            <Text as="h1" variant="4xl-bold">
              <span className="line-clamp-2">Curriculum Schemes</span>
            </Text>
          </div>
        </div>

        <div className="flex mb-12 justify-between gap-8">
          <div className="w-4/6 max-w-[600px]">
            <Text as="h2" className="mb-3" variant="xl-medium">
              <span>What&apos;s included with each Scheme?</span>
            </Text>
            {includedItems.map((item) => (
              <div className="flex rounded-lg border-neutral-150 gap-1 border py-2 pl-2 pr-8 w-fit mb-3 items-center">
                <CurriculumGoalsTick className="min-w-8 w-8 mr-[1px]" />
                <Text as="p" variant="sm-normal">
                  {item}
                </Text>
              </div>
            ))}
            <Text as="p" className="mt-6">
              Find out more about what makes our curriculum schemes unique{" "}
              <a
                href={`${paths.external.TWINKL_URL}/resources/planit-primary-teaching-resources`}
                rel="noopener noreferrer"
                target="_blank"
              >
                here
              </a>
              .
            </Text>
          </div>
          {/* hide on smal screens */}
          <div className="md:w-2/6">
            <img
              className="visible max-lg:hidden"
              role="presentation"
              src={CurriculumGoalsImg}
            />
          </div>
        </div>

        <>
          <Text as="h2" className="mb-2" variant="xl-medium">
            Our Curriculum Design Principles
          </Text>
          <Text as="p">
            Learn more about the subject-specific principles that underpin our
            curriculum design.
          </Text>

          <ul
            className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2
        xl:grid-cols-3 gap-5"
          >
            {CurriculumGoalsBlogPosts.map((post) => (
              <li key={`blog-post-${post.title}`} className="pt-5">
                <a
                  className="flex flex-col rounded-2xl group/card-link transition-colors border-1"
                  href={post.url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div className="h-[140px] w-full flex items-center justify-center rounded-t-lg  group-hover/card-link:bg-neutral-100 group-focus-within/card-link:bg-neutral-100">
                    <img
                      alt=""
                      className="bg-center max-w-full max-h-[191px] h-full py-6"
                      src={
                        SubjectHelper.getCardDecorations(post.slug).imageUrl ||
                        BlogPostImg
                      }
                    />
                  </div>
                  <div className="flex flex-col gap-4 pt-4 px-5 pb-6 bg-white border-gray-200 rounded-b-2xl group-hover/card-link:bg-neutral-100 group-focus-within/card-link:bg-neutral-100">
                    <div className="flex flex-col gap-2">
                      <div className="flex items-top line-clamp-2">
                        <Text as="p" variant="xl-medium">
                          {post.title}
                        </Text>
                      </div>
                      <Text as="p" className="line-clamp-3">
                        {post.description}
                      </Text>
                    </div>
                    <div>
                      <Button
                        className="group-hover/card-link:bg-blue-700 group-focus-within/card-link:bg-blue-700 hover:bg-blue-700"
                        size="sm"
                        tabIndex={-1}
                        variant="secondary"
                        onClick={() =>
                          click("click_cta", {
                            clickLocation: post.title,
                            ctaCopy: "Read more at Twinkl",
                          })
                        }
                      >
                        Read more at Twinkl
                      </Button>
                    </div>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </>
      </div>
    </ContentContainer>
  );
};
